import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Button} from "primeng/button";
import {CardModule} from "primeng/card";
import {SelectChangeEvent, SelectModule} from "primeng/select";
import {PrimeTemplate} from "primeng/api";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {TooltipModule} from "primeng/tooltip";
import {UpperCasePipe} from "@angular/common";
import {getDefaultPageable, Page, Pageable, PageParams} from "../../../core/models/page.model";
import {DEFAULT_ROWS_PER_PAGE_OPTIONS} from "../../../core/utils/utils";
import {IBank} from "../../../core/models/bank.model";
import {BankService} from "../../../core/services/bank.service";
import {countries} from "../../../../assets/countries";
import {environment} from "../../../../environments/environment.development";
import {Observable} from "rxjs";

@Component({
    selector: 'app-search-form',
    imports: [
        Button,
        CardModule,
        SelectModule,
        PrimeTemplate,
        ReactiveFormsModule,
        TooltipModule,
        UpperCasePipe
    ],
    templateUrl: './search-form.component.html',
    styleUrl: './search-form.component.scss'
})
export class SearchFormComponent implements OnInit{

  countries: any[] = []
  production = environment.production;


  @Input() title!: string
  @Input() data!: any[]
  @Input() dataCopy!: any[]

  @Input() banksToDisplay!: IBank[];
  @Output() banksToDisplayChange = new EventEmitter<IBank[]>();

  @Input() counterpartsToDisplay!: any[];
  @Output() counterpartsToDisplayChange = new EventEmitter<any[]>();

  @Input() pageable!: PageParams;
  @Output() pageableChange = new EventEmitter<PageParams>();

  @Input() hasSearched = false;
  @Output() hasSearchedChange = new EventEmitter<boolean>();

  @Input() displaySpinner = false;
  @Output() displaySpinnerChange = new EventEmitter<boolean>();

  @Input() searchForm!: FormGroup
  @Output() searchFormChange = new EventEmitter<any>();

  // pageable: PageParams = {page: 0, first: 0, rows: 0, totalRecords: 0, rowPerPageOptions: []};



  constructor(private formBuilder: FormBuilder,
              private bankService: BankService) {
  }

  ngOnInit() {
    this.initForm();
    this.countries = countries;
  }

  initForm() {
    this.searchForm = this.formBuilder.group({
      country: [null, Validators.required],
      name: [null, Validators.required]
    })
  }

  onSearch(defaultPageable = getDefaultPageable()) {
    this.hasSearchedChange.emit(true);
    this.displaySpinnerChange.emit(true);
    this.searchFormChange.emit(this.searchForm)
    let name = this.searchForm.value.name ?? '';
    let country = this.searchForm.value.country ?? '';

    let searchFn: ((name: string, country: string, pageable: Pageable, isPaged?: boolean) => Observable<Page<any>>) | null = null;
    let isBankComponent = this.title === 'Recherche de banques'
    if (isBankComponent) {
      searchFn = this.bankService.searchBanksByNameAndCountry.bind(this.bankService);
    }

    if (!searchFn)
      return;

    searchFn(name, country, defaultPageable).subscribe({
      next: page => {
        (isBankComponent) ? this.banksToDisplayChange.emit(page.content) : this.counterpartsToDisplayChange.emit(page.content)
        this.displaySpinnerChange.emit(false);

        if (this.production) console.log(page.content)
        const pageable = {
          page: page.number,
          first: page.number * page.size,
          rows: page.size,
          totalRecords: page.totalElements,
          rowPerPageOptions: DEFAULT_ROWS_PER_PAGE_OPTIONS
        }

        this.pageableChange.emit(pageable);
      },
      error: err => {
        if (this.production) console.log(err)
        this.displaySpinnerChange.emit(false);

      }
    })
  }

  countriesDropdownChange(event: SelectChangeEvent) {
    const country = event.value;
    let searchFn: ((name: string, country: string, pageable: Pageable, isPaged: boolean) => Observable<Page<any>>) | null = null;

    switch (this.title) {
      case 'Recherche de banques':
        searchFn = this.bankService.searchBanksByNameAndCountry.bind(this.bankService);
        break;
    }

    if (!searchFn) {
      return;
    }

    searchFn('', country, getDefaultPageable(), false).subscribe({
        next: page => {
          this.dataCopy = page.content;
        },
        error: err => {
          console.error('Erreur lors de la récupération des données :', err);
        }
      });
  }

  onReset() {
    this.searchForm.reset()
    this.resetNameDropDown()
    this.hasSearchedChange.emit(false);

    if (this.title === 'Recherche de banques')
      this.banksToDisplayChange.emit([])
    this.pageableChange.emit({page: 0, first: 0, rows: 0, totalRecords: 0, rowPerPageOptions: []})

  }
  resetNameDropDown() {
    this.dataCopy = this.data;
  }

}
